<div class="page-container">
  <app-back-link link="/settings/jobs" label="Back to Jobs"></app-back-link>

  <app-loading-spinner [isLoading]="isLoading"></app-loading-spinner>

  <div class="error-panel" *ngIf="errorMessage">{{ errorMessage }}</div>

  <ng-container *ngIf="!isLoading && job">
    <div class="job-header">
      <div class="job-title-row">
        <span class="job-type-badge">{{ job.job_type }}</span>
        <span class="status-badge" [ngClass]="statusClass(job.status)">{{ job.status }}</span>
        <span *ngIf="job.attempt_count > 1" class="attempts-badge">{{ job.attempt_count }} attempts</span>
      </div>
      <div class="job-meta">
        <span *ngIf="job.entity_type" class="meta-item">
          {{ job.entity_type }}<span *ngIf="job.entity_id" class="dim">#{{ job.entity_id }}</span>
        </span>
        <span class="meta-item dim">Created {{ job.created_at | date:'MMM d, y, h:mm a' }}</span>
        <span class="meta-item dim" *ngIf="job.completed_at">
          Completed {{ job.completed_at | date:'MMM d, y, h:mm a' }}
        </span>
      </div>
      <div class="job-message" *ngIf="job.message">{{ job.message }}</div>
    </div>

    <ng-container *ngIf="job.system_prompt || job.user_prompt || job.llm_output; else noLlmData">
      <div class="prompt-section">
        <h3 class="section-label">System Prompt</h3>
        <pre class="prompt-block" *ngIf="job.system_prompt">{{ job.system_prompt }}</pre>
        <p class="dim" *ngIf="!job.system_prompt">Not recorded.</p>
      </div>

      <div class="prompt-section">
        <h3 class="section-label">User Prompt</h3>
        <pre class="prompt-block" *ngIf="job.user_prompt">{{ job.user_prompt }}</pre>
        <p class="dim" *ngIf="!job.user_prompt">Not recorded.</p>
      </div>

      <div class="prompt-section">
        <h3 class="section-label">LLM Output</h3>
        <pre class="prompt-block output-block" *ngIf="job.llm_output">{{ job.llm_output }}</pre>
        <p class="dim" *ngIf="!job.llm_output">No output recorded.</p>
      </div>
    </ng-container>

    <ng-template #noLlmData>
      <p class="dim no-llm-msg">No LLM prompt data was recorded for this job.</p>
    </ng-template>
  </ng-container>
</div>
